const rouConfig = [
  {
    path: 'MenuQuery',
    name: 'MenuQuery',
    meta: {
      name: '餐单查询',
    },
    component: () => import('./MenuQuery')
  },
 

];

export default rouConfig;